/**
 * AmbientDashboardPage - Ambient operations display
 *
 * Surfaces the AmbientDashboard from portal components for admin/architect users.
 * Provides ambient display mode for facility meeting rooms and common areas.
 *
 * Route: /admin/ambient-dashboard
 */

import { Container, Title, Group, Badge, Text, ThemeIcon, Alert } from '@mantine/core';
import { IconDeviceTv, IconInfoCircle } from '@tabler/icons-react';

import { AmbientDashboard } from '@/components/ambient/AmbientDashboard';
import { useAuth } from '@/auth/AuthContext';

// Mock data for the ambient dashboard demo
const DEMO_ITEMS = [
  { id: '1', name: 'Task Queue', status: 'Active', safetyLevel: 'normal' },
  { id: '2', name: 'Compliance Status', status: 'Monitoring', safetyLevel: 'normal' },
];

const DEMO_ALERTS = [
  { id: '1', message: 'System operating normally', severity: 'MEDIUM' as const, timestamp: new Date() },
];

export function AmbientDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="cyan">
            <IconDeviceTv size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Ambient Dashboard</Title>
            <Text size="sm" c="dimmed">
              Ambient display mode for facility meeting rooms and common areas
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <Alert icon={<IconInfoCircle size={16} />} title="Demo Mode" color="blue" mb="lg">
        Use /ambient for the full-screen ambient display. This admin view shows a preview with demo data.
      </Alert>

      <AmbientDashboard items={DEMO_ITEMS} alerts={DEMO_ALERTS} />
    </Container>
  );
}

export default AmbientDashboardPage;
